import styled from 'styled-components';

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (max-width: 1023px) {
    width: 100%;
    margin-top: 20px;

    & > div {
      text-align: right;
    }

    .outlineButton {
      width: calc(50% - 5px);
    }
  }

  @media screen and (max-width: 580px) {
    flex-direction: column;
    & > div {
      text-align: center;
    }
    .outlineButton {
      width: 100%;
    }
  }
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-items: center;
  h2,
  span {
    color: #595959;
    font-size: 16px;
    font-weight: normal;
    margin: 0;
    font-family: inherit;
  }
  a {
    h2 {
      transition-duration: 0.3s;
    }
    &:hover {
      h2 {
        color: #00bcd4;
      }
    }
  }
  @media screen and (max-width: 1023px) {
    flex-direction: column;
    > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      i {
        font-size: 20px;
      }
      i,
      h2 {
        margin-top: 0 !important;
      }
    }
  }
`;

const AlignCenterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

const DescriptionBlock = styled.div`
  display: block;
  font-family: 'Lato';
  font-size: 16px;
  line-height: 24px;
  white-space: pre-line;
  color: #595959;
  word-wrap: anywhere;
`;

const CardWrapper = styled.div`
  background-color: white;
  padding: 20px 12px;
  margin-bottom: 15px;
  .column {
    border-bottom: 1px solid #f9f9f9;
    &:nth-child(4n + 3),
    &:nth-child(4n) {
      background-color: #fafafa;
    }
  }
  .desc-span-table {
    display: block;
    padding: 14px 0;
  }
`;

const AdsBottomWrapper = styled.div`
  background-color: white;
  padding: 30px;
  @media (max-width: 580px) {
    padding: 15px;
  }
`;

const AdsInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  button {
    border-width: 1px;
    border-style: solid;
    border-color: rgba(11, 47, 63, 0.2);
    min-height: auto;
    min-width: auto;
    padding: 0px 15px;
    color: #00bcd4;
    text-align: right;
    font-size: 15px;
    font-weight: bold;
    white-space: nowrap;
  }
  @media (max-width: 580px) {
    button {
      border-width: 0;
      padding: 0;
      .btn-icon {
        img {
          margin: 0;
        }
      }
      .btn-text {
        display: none;
      }
    }
  }
`;

const AdsDetailWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid #eeeef1;
  justify-content: space-between;
  padding-bottom: 30px;
  @media (max-width: 580px) {
    padding-bottom: 15px;
  }
`;

const AdsDescriptionWrapper = styled.div`
  padding: 30px 0 0;
  @media (max-width: 580px) {
    padding: 15px 0 0;
  }
`;

const AdsExtraWrapper = styled.div`
  padding: 20px;
  border: 1px solid rgba(11, 47, 63, 0.2);
  border-radius: 2px;
  margin-top: 30px;
`;

const SubinfoWrapper = styled.div`
  display: grid;
  @media screen and (min-width: 75em) {
    grid-template-columns: repeat(auto-fill, minmax(33%, 1fr));
  }
  @media screen and (min-width: 64em) {
    grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
  }
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  & > div {
    display: flex;
    flex: 1 1 33%;
    & {
      margin-bottom: 10px;
    }
    .column {
      margin-right: 10px;
      .desc-span-table {
        color: #595959;
        white-space: nowrap;
        &.value {
          color: #0b2f3f;
        }
      }
    }
  }
`;

const AdsShareWrapper = styled.div`
  padding: 30px 0 0;

  .outlineButton {
    .btn-text {
      font-size: 15px;
      font-weight: bold;
      color: #00bcd4;
    }
  }
`;

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export {
  DescriptionBlock,
  AlignCenterWrapper,
  InfoBoxWrapper,
  ButtonWrapper,
  CardWrapper,
  ContactWrapper,
  AdsInfoWrapper,
  AdsDescriptionWrapper,
  AdsBottomWrapper,
  AdsShareWrapper,
  AdsExtraWrapper,
  SubinfoWrapper,
  AdsDetailWrapper,
};
